export default String.raw`
<g id="Title + breadcrumbs" clip-path="url(#clip0_12968_153466)" fill="none">
<rect width="360" height="100" fill="white"/>
<g id="Breadcrumbs">
    <foreignObject x="16" y="16" width="328" height="24">
        <div xmlns="http://www.w3.org/1999/xhtml" class="primaryColorFont" style="display: flex; align-items: center; gap: 6px; font-family: Inter; font-size: 14px; letter-spacing: 0px; white-space: nowrap; overflow: hidden;">
            <span>TRANSLATION_Prv_FilterPanel_Breadcrumb_DesktopComputers</span>
            <span>/</span>
            <span>TRANSLATION_Prv_FilterPanel_Breadcrumb_ComputerComponents</span>
            <span>/</span>
            <span>TRANSLATION_Prv_FilterPanel_Breadcrumb_Processors</span>
        </div>
    </foreignObject>
</g>
<g id="Page title">
    <foreignObject x="16" y="52" width="328" height="36">
        <div xmlns="http://www.w3.org/1999/xhtml" style="display: flex; align-items: baseline; gap: 8px; font-family: Inter; letter-spacing: 0px;">
            <span class="primaryColorFont" style="font-size: 24px; font-weight: 500;">TRANSLATION_Prv_FilterPanel_Breadcrumb_Processors</span>
            <span class="secondaryColorFont" style="font-size: 16px;">(1135)</span>
        </div>
    </foreignObject>
</g>
</g>
<defs>
<clipPath id="clip0_12968_153466">
<rect width="360" height="100" fill="white"/>
</clipPath>
</defs>
`;